import React, { useContext, useEffect, useState } from "react";
import { Layout, message, theme, Row } from "antd";
import Sidebar from "../../Components/Sidebar/sidebar";
import DashboardHeader from "../../Components/DashboardHeader/dashboardHeader";
import { Outlet } from "react-router-dom";
import dashboardService from "../../services/dashboardService";
import { ThemeContext } from "../../context/themeProvider";
import { Web3Provider } from "../../Components/wallet/walletConnect";
import { Modal } from "antd";
import EarnBaaiTokensModal from "../../Components/DashboardComponents/EarnBaaiTokensModal";
import SurveyModal from "../../Components/DashboardComponents/ServeyModal";
import { useSelector } from "react-redux";
import axios from "axios";
import { focii_url, feedback_key, plugin_url } from "../../config";
import { useLocation } from "react-router-dom";
import circle from "../../assets/right-sircle.png";
import { store } from "../../Components/Redux/store";
import {
  setPromotionFalse,
  setPromotionTrue,
} from "../../Components/Redux/actions";

const DashboardLayout = (props) => {
  const [surveyOpen, setSurvey] = useState(false);
  const [isSuccessModalOpen, setSuccessModal] = useState(false);
  const [videoIdState, setVideoId] = useState("None");
  const location = useLocation();
  let url = location.search.substring(location.search.indexOf("?") + 1);
  const yturl = url.startsWith("https://www.youtube.com");
  const cardBackgroundColor = "#F3F3F5";
  const [collapsed, setCollapsed] = useState(true);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const { headerTitle } = props;
  const [userProfile, setUserProfile] = useState("");
  const { setLoading } = useContext(ThemeContext);

  const getDetailsFunc = async () => {
    try {
      setLoading(true);
      const response = await dashboardService.getUserDetails();
      if (response.error) {
        message.destroy();
        message.error(
          response?.error?.message ||
            "Something went worng in getting user details"
        );
      } else {
        setUserProfile(response?.data);
        dashboardService.setUserProfile(response?.data);

        // if (!response?.data?.userDetails?.extInstalled) {
        //   await dashboardService.pluginInstalledStatus();
        // }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      return;
    }
  };

  const fetchPluginUserData = async () => {
    const queryParams = new URLSearchParams(location.search);
    // console.log("Redirected URL =>", queryParams);
    // const feedbackParam = queryParams.get('showfeedback');
    const videoIdParam = queryParams.get("videoId");
    console.log("VideoId present in params ", videoIdParam);
    setVideoId(videoIdParam);
    console.log("Vide STate", videoIdState);
    if (!videoIdParam) {
      if (!localStorage.getItem("videoId")) {
        console.log("VideoId not present in param or local storage");
      } else {
        setVideoId(localStorage.getItem("videoId"));
      }
    }

    let userId = localStorage.getItem("userProfile");
    if (!userId) {
      return;
    }
    userId = JSON.parse(userId);

    const finalId = userId["userDetails"]["_id"];
    const userEmail = userId["userDetails"]["email"];

    //  console.log(finalId,userEmail)
    if (userProfile?.userDetails?.extInstalled) {
      store.dispatch(setPromotionTrue());
    } else {
      try {
        const response = await axios.get(
          `${plugin_url}/plugin/api/user/pluginStatus/${finalId}`
        );
        console.log("Verified user");
        if (response.status === 200) {
          store.dispatch(setPromotionTrue());
        }
      } catch (err) {
        console.log("Plugin Not Used Error", err.message);
        return;
      }
    }
    //checking for feedback
    try {
      const response = await axios.get(
        `${focii_url}/feedback/v1/feedbackExist?email=${userEmail}&type=consumer`,
        {
          headers: {
            "feedback-key": `${feedback_key}`,
          },
        }
      );
      console.log(response.data.data);

      if (response.data.data === false) {
        setSurvey(true);
      } else {
        console.log("Review ALready Submitted");
        store.dispatch(setPromotionTrue());
      }
    } catch (err) {
      console.log("Not able to fetch feedback data", err.message);
    }
  };

  useEffect(() => {
    getDetailsFunc();
    if (url.includes("newuser=true")) {
    } else if (!yturl) {
      if (!url.includes("showfeedback")) {
        // window.open("https://www.youtube.com","_newYT").focus()
      }
    } else {
      setTimeout(() => {
        let newWin = window.open(url, "_newYT");
        if (!newWin || newWin.closed || typeof newWin.closed == "undefined") {
          alert(`Please allow Popup/Redirect permissions.`);
        }
      }, 1000);
    }
  }, []);

  useEffect(() => {
    // Scroll to the top of the page on route change
    window.scrollTo(0, 0);
    (async () => await fetchPluginUserData())();
    store.dispatch(setPromotionFalse());
  }, [headerTitle, userProfile]);

  // useEffect(()=>{
  //   let button = document.getElementsByClassName("anticon anticon-bars");
  //   console.log(button)
  //   if(button){
  //     button[0]?.addEventListener("click",()=>{
  //      console.log("clickkedd")
  //     })
  //   }

  // },[document.getElementsByClassName("anticon anticon-bars")])

  //for Survey Modal

  // for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setSuccessModal(false);
  };

  const promotion = useSelector((state) => state.promotion.isCompleted);

  return (
    <>
      {!promotion && (
        <Row className="top-blue-header">
          <p>
            Earn more BAAI tokens while watching your favourite YouTube Video.{" "}
            <button onClick={showModal}> Start Earning..!</button>
          </p>
        </Row>
      )}

      <Layout className="mobile-overflow">
        <Sidebar
          getDetailsFunc={getDetailsFunc}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />
        <Layout>
          <Web3Provider>
            <DashboardHeader
              colorBgContainer={colorBgContainer}
              headerTitle={headerTitle}
              collapsed={collapsed}
              setCollapsed={setCollapsed}
            />
          </Web3Provider>
          <Outlet
            context={{
              cardBackgroundColor: cardBackgroundColor,
              colorBgContainer: colorBgContainer,
              userProfile: userProfile,
              getDetailsFunc: getDetailsFunc,
            }}
          />
        </Layout>
      </Layout>
      <Modal
        className="earn-baai-tokens-modal"
        centered
        footer={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <EarnBaaiTokensModal handleClose={handleCancel} />
      </Modal>
      <Modal
        // className="earn-baai-tokens-modal"
        centered
        footer={false}
        open={surveyOpen}
        closable={false}
        closeIcon={false}
      >
        <SurveyModal
          setSurvey={setSurvey}
          videoId={videoIdState}
          setSuccessModal={setSuccessModal}
        />
      </Modal>
      <Modal
        className="earn-baai-tokens-sucess"
        centered
        footer={false}
        open={isSuccessModalOpen}
        onOk={() => setSuccessModal(false)}
        onCancel={() => setSuccessModal(false)}
        closeIcon={false}
      >
        <div className="earn-baai-success-modal">
          <img width={60} src={circle} alt="" />
          <h4>Task completed!</h4>
          <p>
            You’ve successfully completed the task. Your rewards will be
            reflected in your BAAI account shortly.
          </p>
          <button
            onClick={() => {
              handleCancel();
              store.dispatch(setPromotionTrue());
            }}
          >
            Close
          </button>
        </div>
      </Modal>
    </>
  );
};

export default DashboardLayout;
